import { createPath, type To } from "react-router-dom";

export type NavigationIntent = "push" | "start" | "finish";

export const navigationState = (intent: NavigationIntent) => ({ navigationIntent: intent });

export function getNavigationIntent(state: unknown): NavigationIntent | undefined {
  if (!state || typeof state !== "object" || !("navigationIntent" in state)) return;
  const intent = state.navigationIntent;
  return intent === "push" || intent === "start" || intent === "finish" ? intent : undefined;
}

export function workspaceHome(pathname: string): string | undefined {
  return pathname.match(/^\/b\/[^/]+\/l\/[^/]+(?=\/|$)/)?.[0];
}

export function isSectionRoot(pathname: string): boolean {
  const home = workspaceHome(pathname);
  return !!home && ["", "/clients", "/conversations", "/appointments", "/apps"].includes(pathname.slice(home.length));
}

export function isFormStep(path: string): boolean {
  return /\/(?:clients|services|appointments|calendar-events)\/(?:new(?:\/[^/?#]+)?|[^/?#]+\/edit)(?:[?#]|$)/.test(path);
}

export function navigationPath(to: To): string {
  return typeof to === "string" ? to : createPath(to);
}
